export const DEFAULT_PUBLIC_SETTINGS = {
  brand_name: "TIMES Y MÁS", primary_color: "#f59e0b", whatsapp: "7293-5834", sinpe: "7033-1876", bg_image_url: null,
};

const imgUrl = (url) => (url?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

// Dark text on light colors, white text on dark colors.
export const textOn = (hex) => {
  const n = parseInt((hex || "#f59e0b").slice(1), 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  return (0.299 * r + 0.587 * g + 0.114 * b) > 150 ? "#0f172a" : "#ffffff";
};

export const themeStyle = (s) => ({ "--brand": s.primary_color, "--brand-fg": textOn(s.primary_color) });

export const bgStyle = (s, overlay) => (s.bg_image_url ? {
  backgroundImage: `${overlay ? `linear-gradient(${overlay}, ${overlay}), ` : ""}url("${imgUrl(s.bg_image_url)}")`,
  backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed",
} : {});
